import React from "react"

export default function TestimonialCard(props) {
    const imageUrl = require(`../../assets/reviewer/${props.reviewerImage}`);
  return (
    <div className="testimonial-card border-box bg-white">
      <div className="review">
        <code>{props.review}</code>
        <ion-icon name="pizza"></ion-icon>
      </div>
      <div className="reviewer">
          <div className="reviewer-details">
              <h2>{props.reviewerName}</h2>
              <h3>{props.reviewerAddress}</h3>
          </div>
          <div className="reviewer-photo ">
              <img src={imageUrl} alt="reviewer image" className="border-box"/>
          </div>
      </div>
    </div>
  )
}
